module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-check-f79711a0.svg";